// shared/pdf/documents/PledgeAgingDocument.jsx
import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow } from '../components/PdfTable';
import { fmtINR, fmtDate } from '../pdfUtils';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const COLS = [
  { label: 'Member',   flex: 1.5 },
  { label: 'Category', flex: 1.4 },
  { label: 'Date',     flex: 1 },
  { label: 'Offered',  flex: 1, align: 'right' },
  { label: 'Paid',     flex: 1, align: 'right' },
  { label: 'Pending',  flex: 1, align: 'right' },
  { label: 'Days',     flex: 0.5, align: 'right' },
];

export default function PledgeAgingDocument({ data, theme: themeKey, orientation, sections, filters }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const rows = Array.isArray(data.rows) ? data.rows : [];
  const totPending = rows.reduce((s, r) => s + Number(r.pendingAmount || 0), 0);

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Offering Aging Report" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && <PdfFilterLine filters={filters} theme={t} />}
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Total Pending Offerings', value: String(rows.length), color: t.primary },
              { label: 'Total Pending Amount',  value: fmtINR(totPending),  color: t.statusRed },
            ]} />
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {rows.map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t} highlight="danger"
              values={[row.donorName || 'â€”', row.category || 'â€”', fmtDate(row.pledgeDate), fmtINR(row.pledgedAmount), fmtINR(row.paidAmount), fmtINR(row.pendingAmount), String(row.daysPending ?? 'â€”')]}
            />
          ))}
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}



